var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/filter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pharmacy-Selection",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile---Search-by-address",
    transform: "translate(-71.000000, -767.000000)",
    fill: "#1E3C70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FILTER-AND-MAP",
    transform: "translate(0.000000, 727.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FILTER-AND-MAP-BUTTONS",
    transform: "translate(37.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FILTER"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/filter",
    transform: "translate(32.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0923466,2.5 L3.9079193,2.5 C2.65875879,2.5 2.02849493,4.0155555 2.91355378,4.90061342 L7.65625046,9.64497508 L7.65625046,14.6874908 C7.65625046,15.1301077 7.8646392,15.546914 8.21875063,15.8593649 L10.0937512,17.2382506 C11.0099526,17.8785333 12.3437518,17.2833092 12.3437518,16.1132515 L12.3437518,9.64497508 L17.0867122,4.90061342 C17.9699839,4.01734261 17.3439974,2.5 16.0923466,2.5 Z M10.9375014,9.06249505 L10.9375014,16.0937397 L9.06250087,14.6874908 L9.06250087,9.06249505 L3.90624938,3.90624894 L16.0937529,3.90624894 L10.9375014,9.06249505 Z",
    id: "Shape"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.73ebab7c1c0beb8db04ad891950ad91e.svg";
export { ForwardRef as ReactComponent };